import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { api } from '../api';
import styles from './Instruction.module.scss';

export const InstructionPage = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const userId = searchParams.get('userId') || '';

  const [instruction, setInstruction] = useState('');
  const [originalInstruction, setOriginalInstruction] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    if (!userId) return;

    const fetchInstruction = async () => {
      try {
        setIsLoading(true);
        setError('');
        const { data } = await api.get(`/admin/users/${userId}/systemInstruction`);
        const value =
          data?.systemInstruction ??
          data?.user?.systemInstruction ??
          '';
        setInstruction(value);
        setOriginalInstruction(value);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load system instruction');
      } finally {
        setIsLoading(false);
      }
    };

    fetchInstruction();
  }, [userId]);

  const handleEditToggle = () => {
    if (!userId) return;
    setIsEditing(true);
  };

  const handleCancel = () => {
    setInstruction(originalInstruction);
    setIsEditing(false);
  };

  const handleSave = async () => {
    if (!userId) return;
    try {
      setIsLoading(true);
      setError('');
      await api.patch(`/admin/users/${userId}/systemInstruction`, {
        systemInstruction: instruction,
      });
      setOriginalInstruction(instruction);
      setIsEditing(false);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update system instruction');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.content}>
        <button
          type="button"
          className={styles.backLink}
          onClick={() => navigate('/admin/dashboard')}
        >
          ← Back to dashboard
        </button>

        <div className={styles.headerRow}>
          <h1 className={styles.header}>System instruction</h1>
        </div>

        {!userId && (
          <p className={styles.error}>No user specified. Please return and select a user.</p>
        )}

        {userId && isLoading && (
          <p className={styles.empty}>Loading instruction...</p>
        )}

        {userId && !isLoading && error && <p className={styles.error}>{error}</p>}

        {userId && !isLoading && !error && (
          <>
            <p className={styles.label}>Instruction</p>
            <textarea
              className={styles.textarea}
              value={instruction}
              onChange={e => setInstruction(e.target.value)}
              readOnly={!isEditing}
            />

            <div className={styles.actions}>
              {!isEditing && (
                <button
                  type="button"
                  className={`${styles.button} ${styles.primary}`}
                  onClick={handleEditToggle}
                >
                  Edit
                </button>
              )}
              {isEditing && (
                <>
                  <button
                    type="button"
                    className={`${styles.button} ${styles.primary}`}
                    onClick={handleSave}
                    disabled={isLoading}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className={`${styles.button} ${styles.secondary}`}
                    onClick={handleCancel}
                    disabled={isLoading}
                  >
                    Cancel
                  </button>
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
};

